import { Component, Prop, h, Fragment } from '@stencil/core';
import { Trim, FinanceOption } from '../../types';
import { formatNumber } from '../../utils/helpers';
import state from '../../store';

@Component({
  tag: 'kia-trim',
  styleUrl: 'kia-trim.scss',
})
export class Priskort {
  @Prop() trim: Trim;
  @Prop() model: App.Models.CarModel;
  @Prop() pricelist: boolean;

  getStoreLink = () => {
    if (this.trim?.order_online) {
      return this.trim.order_online;
    } else if (this.model?.order_online) {
      return this.model.order_online;
    } else {
      return 'https://www.kia.com/se/kopa/bestall-online/';
    }
  };

  render() {
    return this.trim ? (
      <div class={`kia_price_card--trim`}>
        {this.trim.loan?.length && [FinanceOption.All, FinanceOption.Loan].includes(state.activeFinanceOption) ? <kia-loan loan={this.trim.loan[0]} /> : null}
        {this.trim.private_leasing?.length && [FinanceOption.All, FinanceOption.PrivatLeasing].includes(state.activeFinanceOption) ? (
          <kia-privatleasing showPrice={this.model?.show_privatleasing} tax={this.trim.vehicle_tax} data={this.trim.private_leasing[0]} />
        ) : null}
        {this.trim.business_leasing?.length && [FinanceOption.All, FinanceOption.BusinessLease].includes(state.activeFinanceOption) ? (
          <kia-businesslease data={this.trim.business_leasing[0]} />
        ) : null}
        {[FinanceOption.BusinessLease, FinanceOption.All].includes(state.activeFinanceOption) && this.trim.beneficial_value && (
          <Fragment>
            <div class="kia_price_card--module">
              <p>
                <strong>
                  Förmånsvärde fr. ⁷<kia-tooltip toolTitle="Baserat på en marginalskatt på 50%" />
                </strong>
              </p>
              <p>{formatNumber(this.trim.beneficial_value)} kr/mån</p>
            </div>
            <div class="kia_price_card--module">
              <p>
                <strong>Fordonsskatt per år</strong>
              </p>
              <p>{formatNumber(this.trim.vehicle_tax)} kr</p>
            </div>
          </Fragment>
        )}
        {/* {this.trim.financial_leasing?.length ? <kia-finanslease data={this.trim.financial_leasing[0]} /> : null} */}
        {this.trim.price && state.activeFinanceOption === FinanceOption.All ? (
          <div class="kia_price_card--module kia_price_card--recprice">
            <h5>
              Rek. ca.pris
              <kia-tooltip toolTitle="inkl. moms" />
            </h5>
            <p>från {formatNumber(this.trim.price)} kr</p>
            {this.model.rec_price_information || this.trim.rec_price_information ? (
              <p class="kia_price_card--recprice--info">{this.trim.rec_price_information || this.model.rec_price_information}</p>
            ) : null}
          </div>
        ) : null}
        <div class="kia_price_card--retailerswrapper">
          <kia-retailers storeLink={this.getStoreLink()} />
        </div>
      </div>
    ) : null;
  }
}
